<script setup>
import { useFormGroup, props as formGroupProps } from '@phoenix/composables/components/form/formGroup';
import { computed } from 'vue';

const props = defineProps({
  ...formGroupProps,
  isSgphx: {
    type: Boolean,
    default: false,
  },
});

const {
  _shouldDisplayCharLeft,
  charactersLeft,
  displayedErrors,
  errorId,
  field,
  fieldUniqueId,
  helpId,
  isHidden,
  isInvalid,
  labelId,
} = useFormGroup(props);

const charLeftClasses = computed(() => {
  if (props.isSgphx) {
    return field.value.type === 'textarea' ? 'sgphx-text-right sgphx-text-xs sgphx-text-gray-600' : 'sgphx-field-help';
  }

  return field.value.type === 'textarea' ? 'text-right text-xs text-gray-600' : 'field-help';
});
</script>

<template>
  <div v-if="isSgphx" :key="`form-group-sgphx-${fieldUniqueId}`" class="sgphx-form-field">
    <label v-if="field.label && !isHidden && showLabel" :id="labelId" :for="fieldUniqueId" class="sgphx-field-label">
      {{ field.label }}&nbsp;<abbr v-if="field.required" :title="$t('Form.required')" data-cy="form-input-required">
        *
      </abbr>
    </label>

    <div v-if="field.help" :id="helpId" class="sgphx-field-help" v-html="field.help" />
    <slot v-else name="help" />

    <slot />

    <div v-if="_shouldDisplayCharLeft" :class="charLeftClasses">
      {{ $t('Form.charactersLeft', { charactersLeft }) }}
    </div>

    <div v-if="isInvalid" :id="errorId" class="sgphx-field-error" role="alert" aria-live="polite">
      {{ displayedErrors }}
    </div>
  </div>

  <div v-else :key="`form-group-${fieldUniqueId}`" class="form-field">
    <label v-if="field.label && !isHidden && showLabel" :id="labelId" :for="fieldUniqueId" class="field-label">
      {{ field.label }}&nbsp;<abbr v-if="field.required" :title="$t('Form.required')" data-cy="form-input-required">
        *
      </abbr>
    </label>

    <div v-if="field.help" :id="helpId" class="field-help" v-html="field.help" />
    <slot v-else name="help" />

    <slot />

    <div v-if="_shouldDisplayCharLeft" :class="charLeftClasses">
      {{ $t('Form.charactersLeft', { charactersLeft }) }}
    </div>

    <div v-if="isInvalid" :id="errorId" class="field-error" role="alert" aria-live="polite">
      {{ displayedErrors }}
    </div>
  </div>
</template>
